<template>
  <div class="login_content">
    <div class="login_box">
      <div class="nav_box">
        <span class="iconfont icon-fanhui" @click="goHome"></span>
        <span @click="goHome">首页</span>
      </div>
      <div class="title">贵州省建设工程招标投标协会企业会员登录入口</div>
      <img class="bg" src="@/assets/images/login/bg6.png" />
      <div class="hh_box">
        <div class="box">
          <div class="input_box">
            <Input
              key="xm"
              v-model="form.username"
              class="input"
              placeholder="请输入统一社会信用代码"
            >
              <span slot="prepend">统一社会信用代码</span>
            </Input>
            <Input
              key="mm"
              v-model="form.password"
              autocomplete="new-password"
              class="input"
              placeholder="请输入登录密码"
              type="password"
            >
              <span slot="prepend">登录密码</span>
            </Input>
            <div class="flex_mm">
              <Checkbox v-model="checked" class="check_box" @on-change="lookPop"
                >我已阅读《隐私条款》
              </Checkbox>
              <!--              <div class="zhmm" @click="rePwd">-->
              <!--                <span class="iconfont icon-wangjimima"></span>-->
              <!--                <span>忘记密码</span>-->
              <!--              </div>-->
            </div>
            <Button
              :loading="loading"
              class="btn"
              long
              type="primary"
              @click="submit"
              >登录</Button
            >
            <div class="zcbtn">
              还不是会员？<span @click="goRH">立即申请入会</span>
            </div>
          </div>
        </div>
      </div>
      <Modal
        v-model="showModal"
        :closable="false"
        :mask-closable="false"
        ok-text="我已阅读并同意"
        title="隐私条款"
        @on-ok="ok"
      >
        <p class="xy_box" v-html="xyInfo.content"></p>
      </Modal>
    </div>
  </div>
</template>
<script>
import { getStuCode, getLogin, getHyLogin } from "@/api/login";
import { getSingleArticle } from "@/api/home/guild";
export default {
  data() {
    return {
      showModal: false,
      checked: false,
      form: {
        username: "",
        password: "",
      },
      loading: false,
      xyInfo: {
        content: "",
      },
    };
  },
  mounted() {},
  methods: {
    getSingleArticle() {
      getSingleArticle({
        catid: 210,
      }).then((res) => {
        if (res.code == 200 || res.code == 0) {
          this.xyInfo = res.result;
          this.xyInfo.content = this.xyInfo.content.replace(
            /\<span/gi,
            `<span style="font-size:15px!important" `,
          );
        }
      });
    },
    submit() {
      if (this.form.username == "") {
        this.$Message.info("统一社会信用代码不能为空");
        return;
      }
      if (this.form.password == "") {
        this.$Message.info("密码不能为空");
        return;
      }
      if (!this.checked) {
        this.$Message.info("请勾选同意隐私条款！");
        return;
      }
      this.loading = true;
      getHyLogin({
        username: this.form.username,
        password: this.form.password,
      }).then((res) => {
        this.loading = false;
        if (res.code == 200 || res.code == 0) {
          this.$Message.success("登录成功！");
          this.$Cookies.set("xh_userInfo", JSON.stringify(res.result));
          this.showLogin = false;
          this.$router.push("user");
          location.reload();
        } else {
          this.$Modal.error({
            title: "提示",
            content: res.message,
            onOk: () => {},
          });
        }
      });
    },
    lookPop() {
      this.showModal = true;
      this.getSingleArticle(); //隐私条款
    },
    ok() {
      this.checked = true;
    },
    goHome() {
      this.$router.push("/");
    },
    goRH() {
      this.$router.push("apply");
    },
    rePwd() {
      this.$Modal.info({
        title: "提示",
        content: "请联系协会重置密码，联系电话：0851-86587786",
        onOk: () => {},
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.login_content {
  overflow-y: scroll;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.login_box {
  min-width: 1100px;
  overflow: scroll;
  .bg {
    min-width: 1100px;
    width: 100%;
    height: 100vh;
    position: absolute;
    top: 0;
    // object-fit: cover;
  }
  .title {
    position: absolute;
    color: #ffffff;
    font-size: clamp(1rem, 3vw, 3.3rem);
    right: 120px;
    top: 95px;
    letter-spacing: 3px;
    z-index: 1;
  }
  .nav_box {
    position: absolute;
    padding: 20px 50px;
    font-size: 20px;
    display: flex;
    align-items: center;
    z-index: 9999;
    span {
      cursor: pointer;
    }
    .icon-fanhui {
      font-size: 30px;
      margin-right: 10px;
    }
  }
  .hh_box {
    min-width: 1100px;
    position: absolute;
    top: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .box {
      width: 900px;
      display: flex;
      justify-content: center;

      .input_box {
        width: 450px;
        .input {
          width: 100%;
          margin-bottom: 25px;

          /deep/ .ivu-input-group-append {
            background: linear-gradient(270deg, #2d85e2 2%, #5b43df 100%);
            color: #fff;
            width: 100px;
            cursor: pointer;
            border: none;
            font-size: 15px;
          }

          /deep/ .ivu-input-group-prepend {
            background-color: #d0e8ff;
            width: 165px;
            font-size: 15px;
            text-align-last: justify;
            padding: 0 20px;
            color: #333;
          }
        }

        /deep/ .ivu-input-group .ivu-input,
        .ivu-input-group .ivu-input-inner-container {
          height: 40px;
          font-size: 14px;
        }

        .flex_mm {
          margin-bottom: 20px;
          color: #fff;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 14px;
          .check_box {
            /deep/ .ivu-checkbox-inner {
              margin-right: 5px;
            }
          }
          .zhmm {
            cursor: pointer;
            font-size: 13px;
            display: flex;
            align-items: center;
            .iconfont {
              margin-right: 3px;
            }
          }
          .zhmm:hover {
            // color: #2B4BFA;
          }
        }

        .btn {
          height: 40px;
          font-size: 18px;
          letter-spacing: 30px;
          padding-left: 40px;
          background: #2b4bfa;
          box-shadow: 2px 2px 5px 0px rgba(0, 0, 0, 0.4);
          border: none;
        }
        .zcbtn {
          text-align: right;
          margin-top: 20px;
          font-size: 13px;
          color: #fff;
          span {
            cursor: pointer;
            color: orangered;
          }
          span:hover {
            // color: #2B4BFA;
          }
        }
      }
    }
  }
}
.xy_box {
  height: 400px;
  overflow: scroll;
}

/deep/ .ivu-btn-text {
  display: none;
}
</style>
